import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { PlessSharedModule } from '../../../shared/pless-shared.module';
import { KYMW1317Component } from './kymw1317.component';
import { AppCommonsModule } from '../../../commons/app-commons.module';
import { WjCoreModule } from '@grapecity/wijmo.angular2.core';
import { WjGridModule } from '@grapecity/wijmo.angular2.grid';
import { GetApprovalItemListService } from './api-services/get-approval-item-list';
import { ApprovalItemService } from './api-services/approval-item';


/**
 * 企画連絡承認画面 モジュール設定クラス
 *
 * @export KYMW1317Module
 * @class KYMW1317Module
 */
@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        PlessSharedModule,
        AppCommonsModule,
        WjCoreModule,
        WjGridModule
    ],
    declarations: [
        KYMW1317Component
    ],
    providers: [
        GetApprovalItemListService,
        ApprovalItemService
    ]
})
export class KYMW1317Module {
}
